<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { open, showCloseButton = true } = defineProps(["open", "showCloseButton"]);
const emit = defineEmits(["close"]);

const isOpen = computed({
  get: () => open,
  set: (value) => {
    emit("close");
  },
});
</script>
<template>
  <VDialog v-model="isOpen" width="auto" :scrollable="true">
    <VCard>
      <div class="background-container">
        <div class="close-button">
          <img
            v-if="showCloseButton"
            @click="() => emit('close')"
            src="/images/icons/close.svg"
            alt="close dialog"
          />
        </div>


        <div class="plans-container" no-gutters>
          <slot></slot>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>
<style scoped lang="scss">
.background-container {
  background: #f8f9fa;
  min-height: auto;
  padding: 60px 30px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  max-width: 100vw;

  @media (max-width: 1200px) {
    padding: 40px 30px;
    min-height: 580px;
  }

  @media (max-width: 1000px) {
    padding: 35px 25px;
    min-height: 560px;
  }

  @media (max-width: 900px) {
    padding: 30px 20px;
    min-height: 540px;
  }

  @media (max-width: 820px) {
    padding: 25px 15px;
    min-height: 520px;
  }

  @media (max-width: 768px) {
    min-height: auto;
    max-height: 90vh;
    padding: 50px 16px 40px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
}

.plans-container {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  padding: 20px 20px 0;
  max-width: 1400px;
  margin: 0 auto;
  overflow: visible;

  @media (max-width: 1200px) {
    gap: 24px;
    padding: 0 24px;
    max-width: 1000px;
  }

  @media (max-width: 1100px) {
    gap: 22px;
    padding: 0 22px;
    max-width: 950px;
  }

  @media (max-width: 950px) {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 0 32px;
    max-width: 600px;
  }

  @media (max-width: 768px) {
    gap: 20px;
    padding: 40px 20px 20px;
    flex-direction: column;
    align-items: center;
    overflow: visible;
  }

  @media (max-width: 480px) {
    padding: 40px 16px 20px;
    gap: 16px;
  }
}


.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;

  @media (max-width: 768px) {
    position: fixed;
    top: 8px;
    right: 8px;
    z-index: 2010;
  }

  img {
    cursor: pointer;
    transition: all 0.2s ease;
    width: 28px;
    height: 28px;
    opacity: 0.7;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));

    &:hover {
      opacity: 1;
      transform: scale(1.15);
    }
  }
}

@media (max-width: 768px) {
  :deep(.v-overlay__content) {
    min-width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    height: 90vh !important;
    max-height: 90vh !important;
    overflow: hidden !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
  }

  :deep(.v-card) {
    border-radius: 0;
    max-height: 90vh;
    height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
  }
}

:deep(.v-overlay__content) {
  align-items: center !important;
  justify-content: center !important;
  padding: 24px !important;
  max-height: 95vh !important;

  @media (max-width: 768px) {
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    height: 90vh !important;
    max-height: 90vh !important;
  }
}

:deep(.v-card) {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid var(--light-grey);
  margin: 0 auto;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    border-radius: 0;
    border: none;
    max-height: 90vh;
    height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
